import type { Item, ItemDraft } from '@easymoving/types';

/**
 * Rebuild an editable draft from a stored item (drops id, images, denormalized
 * photo URLs, and timestamps). Used to re-create an item on undo-delete.
 */
export function itemToDraft(item: Item): ItemDraft {
  return {
    name: item.name,
    nickname: item.nickname,
    room: item.room,
    category: item.category,
    iconType: item.iconType,
    destination: item.destination,
    progressStatus: item.progressStatus,
    length: item.length,
    width: item.width,
    height: item.height,
    dimensionUnit: item.dimensionUnit,
    dimensionsText: item.dimensionsText,
    weight: item.weight,
    condition: item.condition,
    quantity: item.quantity,
    estimatedValue: item.estimatedValue,
    currency: item.currency,
    boxId: item.boxId,
    storageLocation: item.storageLocation,
    fragile: item.fragile,
    priority: item.priority,
    notes: item.notes,
    privateNotes: item.privateNotes,
    publicNotes: item.publicNotes,
    includeInMoverQuote: item.includeInMoverQuote,
  };
}
